import { all, call, put, take, takeLatest, select } from 'redux-saga/effects';
import {
  LOAD_GOOGLE_MAP_API_SCRIPT,
  autoCompleteAddressChanged,
  FETCH_ADDRESS_OTHER_POLICY_LIST_SUCCESS,
  UPDATE_ADDRESS_OTHER_POLICIES,
  LOAD_GOOGLE_AUTO_COMPLETE_ADDRESS,
  SUBMIT_CHANGE_ADDRESS_FORM,
  SUBMIT_CHANGE_ADDRESS_FORM_SUCCESS,
  SUBMIT_CHANGE_ADDRESS_FORM_FAILURE,
  LOAD_GOOGLE_AUTO_COMPLETE_MAP,
  autoCompleteMapAddressChanged,
  setUpShowAddressPopup,
  setUpConfirmLoadingButton,
  LOAD_GOOGLE_MAP_JS_SCRIPT,
  updateLoadGoogleMapJsScriptStatus,
  UPDATELOAD_GOOGLE_MAP_JS_SCRIPT_STATUS,
  updateEditPageLoading,
  UPDATE_EDIT_PAGE_LOADING,
  AUTO_COMPLETE_MAP_ADDRESS_CHANGED,
  UPDATE_IS_GOOGLE_MAP_JS_SCRIPT_ERROR,
  setIsClearSearchValue,
  setIsAutoFilled,
} from '../actions/changeAddressAction';
import {
  UPDATE_ADDRESS_FEATURE_ID,
  ADDRESS_SUBMISSION_DEFAULT_ERROR_CODE,
} from '../constants/constants';
import { eventChannel } from '@redux-saga/core';
import { Place, PlaceType } from '../types/changeAddressTypes';
import {
  getPlaceName,
  getPlaceNameByMultipleTypes,
} from '../reducers/changeAddressReducer';
import { goto } from '../../../actions/historyActions';
import {
  getSelectedPolicy,
  getCustomerContactsApi,
} from '../selectors/changeContactSelector';
import {
  getNewAddress,
  getSelectedList,
  getOtherPolicyList,
  getChangeAddressLabels,
} from '../selectors/changeAddressSelector';
import { changeContactPolicy } from '../types/changeContactService';
import { fetchOtherPolicyList } from './changeContactSaga';
import { showErrorModal } from '../../../actions/uiActions';
import { isApp, resolveLocalizedText } from '../../../utils';
import { callBackErrorCodePage } from '../utils';
import { myAxaFetchWithToken } from '../../../utils/myAxaFetchWithToken';
import uuidv4 from 'uuid/v4';
import _ from 'lodash';
import env from '../../../env';
import { loadScriptToTag } from '../../../actions/appActions';
import { store } from '../../../stores';
import locationSvg from '../../../assets/images/location-bg.svg';
import { normaliseAddress } from '../utils/editAddressUtils';

const googleMapApiScript: any = null;
export const GOOGLE_PLACE_AUTO_INPUT_ID = 'hk-address-auto-fill-input';
export const autocompleteOptions = {
  componentRestrictions: { country: 'hk' },
  fields: ['address_components', 'name'],
};

const GOOGLE_MAP_ID = 'MAP_ID';

function* loadGoogleMapApiScript() {
  /** TODO: Load Google MAP Script ONLY When needed. Don't place it at index.html */
  // const doc = document.getElementsByTagName('head')[0];
  // const scriptUrl = `https://maps.googleapis.com/maps/api/js?key=&libraries=places&callback=initMap`;
  // googleMapApiScript && doc.removeChild(googleMapApiScript);
  // googleMapApiScript = document.createElement('script');
  // googleMapApiScript.setAttribute('async', 'true');
  // googleMapApiScript.setAttribute('src', scriptUrl);
  // doc.appendChild(googleMapApiScript);

  // Init the autocomplete field
  yield all([initAutocompleteField(), initAutocompleteMap()]);
}

function setupLoadingEditPage() {
  store.dispatch({
    type: UPDATE_EDIT_PAGE_LOADING,
    payload: {
      isLoadingEditPage: false,
    },
  });
}

function* loadGoogleMapJsScript() {
  yield put(updateEditPageLoading(true));
  yield put(updateLoadGoogleMapJsScriptStatus(false));
  const mapUrl = `https://maps.googleapis.com/maps/api/js?key=${env.GOOGLE_MAPS_KEY}&libraries=places,marker&callback=initMap&language=en`;
  loadScriptToTag(mapUrl, 'head')
    .then((res) => {
      setupLoadingEditPage();
      if (res) {
        store.dispatch({
          type: UPDATELOAD_GOOGLE_MAP_JS_SCRIPT_STATUS,
          payload: {
            isGoogleMapJsScriptComplete: true,
          },
        });
        store.dispatch({
          type: LOAD_GOOGLE_AUTO_COMPLETE_ADDRESS,
        });
        store.dispatch({
          type: UPDATE_IS_GOOGLE_MAP_JS_SCRIPT_ERROR,
          isError: false,
        });
      }
    })
    .catch((e) => {
      setupLoadingEditPage();
      // const errorCode = "cicGoogleMapDefaultErrorCode";
      // goto(`emma-general-error-code?error_code=${errorCode}`)
      console.error('error when loading google map script', e);
      store.dispatch({
        type: UPDATE_IS_GOOGLE_MAP_JS_SCRIPT_ERROR,
        isError: true,
      });
    });
}

function* initAutocompleteField() {
  const input = document.getElementById(
    GOOGLE_PLACE_AUTO_INPUT_ID,
  ) as HTMLInputElement;
  const tcWindow = window as any;
  const google = tcWindow && (tcWindow.google as any);
  if (google) {
    const autocomplete = new google.maps.places.Autocomplete(
      input,
      autocompleteOptions,
    );
    // Bridge between callback and saga
    const channel = eventChannel((emitter) => {
      autocomplete.addListener('place_changed', () => {
        const data = autocomplete.getPlace() as Place;
        emitter({ data });
      });
      return () => {};
    });
    while (true) {
      const { data } = yield take(channel);
      if (!!data && !!data.address_components) {
        const addressInput = tranferAddressData(data);
        yield put(autoCompleteAddressChanged(addressInput));
        yield put(setIsClearSearchValue(true));
        yield put(setIsAutoFilled(true));
      }
    }
  }
}

function getTranferedAddressData(results: any) {
  const premiseData = results.find(
    (v: any) => v && v.types && v.types.includes(PlaceType.premise),
  );
  const establishmentData = results.find(
    (v: any) => v && v.types && v.types.includes(PlaceType.establishment),
  );
  const routeData = results.find(
    (v: any) => v && v.types && v.types.includes(PlaceType.route),
  );
  const placeData = premiseData || establishmentData || routeData;
  const tranferedAddressData = tranferAddressData(placeData);
  return tranferedAddressData;
}

function* initAutocompleteMap(action?: any) {
  try {
    let isCurrentLocationAvailable = false;
    let lati = 22.3193;
    let longi = 114.1694;
    if (action?.payload?.objLocation) {
      const { latitude, longitude } = action.payload.objLocation;
      lati = latitude;
      longi = longitude;
      isCurrentLocationAvailable = true;
    }

    const tcWindow = window as any;
    const google = tcWindow && (tcWindow.google as any);
    const myLatlng = new google.maps.LatLng(lati, longi);
    const HONG_KONG_BOUNDS = {
      north: 22.6,
      south: 21.9,
      west: 113.7,
      east: 114.5,
    };
    const myOptions = {
      mapId: GOOGLE_MAP_ID,
      minZoom: 10,
      zoom: isCurrentLocationAvailable ? 15 : 10,
      mapTypeControlOptions: {
        mapTypeIds: [],
      },
      mapTypeId: google.maps.MapTypeId.ROADMAP,
      streetViewControl: true,
      center: myLatlng,
      restriction: {
        latLngBounds: HONG_KONG_BOUNDS,
        strictBounds: false,
      },
    };
    const mapCanvasId = document.getElementById('map-canvas');
    if (!mapCanvasId) return;
    const map = new google.maps.Map(mapCanvasId, myOptions);
    // set up user current position
    const pinImg = document.createElement('img');
    pinImg.width = 32;
    pinImg.height = 32;
    pinImg.src = locationSvg;

    const { mapGuidanceMsg } = yield select(getChangeAddressLabels);
    const guidanceMsg = document.createElement('div');
    guidanceMsg.className = 'guidanceMsgContainer';
    guidanceMsg.textContent = resolveLocalizedText(mapGuidanceMsg);

    const pinWithMessage = document.createElement('div');
    pinWithMessage.className = 'pinWithGuidanceMsg';
    pinWithMessage.appendChild(guidanceMsg);
    pinWithMessage.appendChild(pinImg);

    let isShowingGuidanceMsg = true;
    let currentLocationMarker;
    if (isCurrentLocationAvailable) {
      currentLocationMarker = new google.maps.marker.AdvancedMarkerElement({
        position: myLatlng,
        map,
        content: pinWithMessage,
      });
    }

    map.addListener('drag', () => {
      if (isShowingGuidanceMsg) {
        currentLocationMarker && currentLocationMarker.setMap(null);
        if (isCurrentLocationAvailable) {
          currentLocationMarker = new google.maps.marker.AdvancedMarkerElement({
            position: myLatlng,
            map,
            content: pinImg,
          });
        }
        isShowingGuidanceMsg = false;
      }
    });

    const geocoder = new google.maps.Geocoder();
    if (isCurrentLocationAvailable) {
      // init current location information
      geocoder &&
        geocoder.geocode(
          {
            location: myLatlng,
          },
          function (results: any, status: any) {
            if (results && status === google.maps.GeocoderStatus.OK) {
              const tranferedAddressData = getTranferedAddressData(results);
              store.dispatch({
                type: AUTO_COMPLETE_MAP_ADDRESS_CHANGED,
                payload: {
                  placeData: tranferedAddressData,
                },
              });
              store.dispatch({
                type: UPDATE_IS_GOOGLE_MAP_JS_SCRIPT_ERROR,
                isError: false,
              });
            } else {
              store.dispatch({
                type: UPDATE_IS_GOOGLE_MAP_JS_SCRIPT_ERROR,
                isError: true,
              });
              goto('emma-customer-profile/changeaddress/edit', '', {}, true);
            }
          },
        );
    }

    const channel = eventChannel((emitter) => {
      let marker: any;
      google.maps.event.addListener(map, 'click', function (event: any) {
        geocoder.geocode(
          {
            latLng: event.latLng,
          },
          function (results: any, status: any) {
            console.log(results);
            if (results && status === google.maps.GeocoderStatus.OK) {
              // Find out building address by priority
              const premiseData = results.find(
                (v: any) => v && v.types && v.types.includes(PlaceType.premise),
              );
              const establishmentData = results.find(
                (v: any) =>
                  v && v.types && v.types.includes(PlaceType.establishment),
              );
              const routeData = results.find(
                (v: any) => v && v.types && v.types.includes(PlaceType.route),
              );
              const placeData = premiseData || establishmentData || routeData;
              const tranferedAddressData = tranferAddressData(placeData);
              const isEmpty =
                _.isEmpty(tranferedAddressData.streetBuildingEstate1) &&
                _.isEmpty(tranferedAddressData.streetBuildingEstate2);
              if (placeData && !isEmpty) {
                // Add marker to clicked place
                currentLocationMarker && currentLocationMarker.setMap(null);
                marker && marker.setMap(null);
                marker = new google.maps.marker.AdvancedMarkerElement({
                  position: event.latLng,
                  map: map,
                  content: pinImg,
                });
                isShowingGuidanceMsg = false;
                console.log(placeData);
                emitter({ data: placeData });
              } else {
                console.log('Not a building.');
              }
            }
          },
        );
      });
      return () => {};
    });
    while (true) {
      const { data } = yield take(channel);
      if (!data) {
        break;
      }
      const addressInput = tranferAddressData(data);
      yield put(autoCompleteMapAddressChanged(addressInput));
    }
  } catch (e) {
    console.log(e);
  }
}

function tranferAddressData(data: any) {
  const placeData = data as Place;
  // parse the places response to correspondent fields
  const region = getPlaceName(placeData, PlaceType.country);
  const district = getPlaceNameByMultipleTypes(placeData, [
    PlaceType.neighborhood,
    PlaceType.political,
  ]);
  const street = getPlaceName(placeData, PlaceType.route);
  const streetNumber = getPlaceName(placeData, PlaceType.street_number);
  const streetBuildingEstate1 =
    getPlaceName(placeData, PlaceType.premise) ||
    getPlaceName(placeData, PlaceType.establishment) ||
    placeData.name;
  const AddressInput = {
    streetBuildingEstate1: normaliseAddress(streetBuildingEstate1),
    streetBuildingEstate2: normaliseAddress(
      `${streetNumber ? streetNumber + ' ' : ''}${street}`,
    ),
    district: normaliseAddress(district),
    region,
  };
  return AddressInput;
}

function* updateOtherPolices() {
  try {
    yield put(setUpConfirmLoadingButton(true));
    const selectedPolicy = yield select(getSelectedPolicy);
    const otherPolicyList = yield call(fetchAddressOtherPolicyList);
    if (
      otherPolicyList.filter(
        (policy: changeContactPolicy) =>
          policy.policyNumber !== selectedPolicy.policyNumber,
      ).length > 0
    ) {
      goto('emma-customer-profile/changeaddress/updatepolicy');
    } else {
      goto('emma-customer-profile/changeaddress/review');
    }
  } catch (e) {
    yield put(showErrorModal());
  } finally {
    yield put(setUpShowAddressPopup(false));
    yield put(setUpConfirmLoadingButton(false));
  }
}

function* fetchAddressOtherPolicyList() {
  const newAddress = yield select(getNewAddress);
  let otherPolicyList = yield call(fetchOtherPolicyList, 'updateAddress', {
    newAddressLine1: newAddress.addrLine1,
    newAddressLine2: newAddress.addrLine2,
    newAddressLine3: newAddress.addrLine3,
    newAddressLine4: `${
      newAddress.addrLine4 ? newAddress.addrLine4 + ' ' : ''
    }${newAddress.districtAddress} ${newAddress.country}`,
  });
  otherPolicyList = _.filter(
    otherPolicyList,
    (item) => item.entityCode === 'LHK',
  );
  yield put({
    type: FETCH_ADDRESS_OTHER_POLICY_LIST_SUCCESS,
    otherPolicyList,
  });
  return otherPolicyList;
}

function* submitChangeAddressForm(action: { type: string }) {
  try {
    const newAddress = yield select(getNewAddress);
    const customerContactsApi = yield select(getCustomerContactsApi);
    const selectedPolicy = yield select(getSelectedPolicy);
    const selectedList = yield select(getSelectedList);
    const otherPolicyList = yield select(getOtherPolicyList);
    const selectedMainPolicy = otherPolicyList.find(
      (policy: any) => policy.policyNumber === selectedPolicy.policyNumber,
    );
    const selectedPolicyList = selectedList.map((policy: any) => ({
      policyNumber: policy.policyNumber,
      eCommFlag: policy.eCommEligible,
      entityCode: policy.entityCode,
    }));
    const { address = {} } = selectedPolicy;
    let newAddressLineArray = [
      newAddress.addrLine1.toUpperCase(),
      newAddress.addrLine2.toUpperCase(),
      newAddress.addrLine3.toUpperCase(),
      `${newAddress.addrLine4}${newAddress.addrLine4 ? ' ' : ''}${
        newAddress.districtAddress
      } ${newAddress.country}`.toUpperCase(),
    ];
    newAddressLineArray = _.filter(newAddressLineArray, (item) => !!item);
    const paraNewAddressLineArray = [];
    for (let i = 0; i < 4; i++) {
      const item = newAddressLineArray[i] ? newAddressLineArray[i] : '';
      paraNewAddressLineArray.push(item);
    }
    const res = yield call(
      myAxaFetchWithToken,
      customerContactsApi,
      {
        method: 'PUT',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify({
          updateCustomerContactsRequest: {
            requestID: uuidv4(),
            featureName: 'updateAddress',
            platform: isApp() ? 'APP' : 'WEB',
            policy: {
              policyNumber: selectedMainPolicy.policyNumber,
              eCommFlag: selectedMainPolicy.eCommEligible,
              entityCode: selectedMainPolicy.entityCode,
              oldAddressLine1: address.addrLine1,
              oldAddressLine2: address.addrLine2,
              oldAddressLine3: address.addrLine3,
              oldAddressLine4: address.addrLine4,
              newAddressLine1: paraNewAddressLineArray[0],
              newAddressLine2: paraNewAddressLineArray[1],
              newAddressLine3: paraNewAddressLineArray[2],
              newAddressLine4: paraNewAddressLineArray[3],
            },
            additionalpolicies: selectedPolicyList,
          },
        }),
      },
      undefined,
      undefined,
      0,
    );
    const data: any = yield res.json();
    const response = (data && data.response) || {};
    if (response.transactionId) {
      yield put({
        type: SUBMIT_CHANGE_ADDRESS_FORM_SUCCESS,
        transactionId: response.transactionId,
        transactions: response.transactions,
      });
      goto('emma-customer-profile/changeaddress/confirm');
    } else {
      callBackErrorCodePage(
        UPDATE_ADDRESS_FEATURE_ID,
        ADDRESS_SUBMISSION_DEFAULT_ERROR_CODE,
      );
    }
  } catch (error) {
    callBackErrorCodePage(
      UPDATE_ADDRESS_FEATURE_ID,
      ADDRESS_SUBMISSION_DEFAULT_ERROR_CODE,
    );
    yield put({
      type: SUBMIT_CHANGE_ADDRESS_FORM_FAILURE,
    });
  }
}

function* changeAddressSaga() {
  yield takeLatest(LOAD_GOOGLE_MAP_API_SCRIPT, loadGoogleMapApiScript);
  yield takeLatest(LOAD_GOOGLE_MAP_JS_SCRIPT, loadGoogleMapJsScript);
  yield takeLatest(UPDATE_ADDRESS_OTHER_POLICIES, updateOtherPolices);
  yield takeLatest(LOAD_GOOGLE_AUTO_COMPLETE_ADDRESS, initAutocompleteField);
  yield takeLatest(SUBMIT_CHANGE_ADDRESS_FORM, submitChangeAddressForm);
  yield takeLatest(LOAD_GOOGLE_AUTO_COMPLETE_MAP, initAutocompleteMap);
}

export default changeAddressSaga;
